import { Button, DatePicker, Form, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { GetHistorical, GetLastSPAL } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterRDSPAL = ({ onData, onDataToleransi }) => {

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [loadings, setLoadings] = useState(false);
    const [form] = Form.useForm();

    const [dataSPAL, setDataSPAL] = useState([]);
    const [selectedSPAL, setSelectedSPAL] = useState(null);

    const fetchDataReading = async (start, end) => {
        try {
            const response = await GetHistorical(KodeCabang, ShipCode, start, end, onDataToleransi[0], onDataToleransi[1]);
            onData(response);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadings(false);
        }
    };

    useEffect(() => {
        const fetchLastSPAL = async () => {
            try {
                const response = await GetLastSPAL(KodeCabang, ShipCode, 0);

                if (response) {
                    setDataSPAL(response);

                    if (response.length > 0) {
                        const defaultSPAL = response[0];
                        const StartDate = dayjs.utc(defaultSPAL.StartDate).format('YYYY-MM-DD HH:mm:ss');
                        const EndDate = dayjs.utc(defaultSPAL.EndDate).format('YYYY-MM-DD HH:mm:ss');
                        setSelectedSPAL(defaultSPAL.SONumber);
                        form.setFieldsValue({
                            SPAL: defaultSPAL.SONumber,
                            RangeDate: [
                                dayjs(StartDate),
                                dayjs(EndDate),
                            ],
                        });
                        fetchDataReading(StartDate, EndDate);
                    }
                } else {
                    console.error("Response does not contain an array for SPAL");
                }
            } catch (error) {
                console.error("Error fetching SPAL data:", error);
            }
        };
        fetchLastSPAL();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [KodeCabang, ShipCode, form]);

    const handleSPALChange = (value) => {
        setSelectedSPAL(value);
        // Opsional: Jika ingin mengubah rentang tanggal berdasarkan SPAL yang dipilih
        const selectedSPALData = dataSPAL.find(item => item.SONumber === value);
        if (selectedSPALData && selectedSPALData.StartDate) {
            const StartDate = dayjs.utc(selectedSPALData.StartDate).format('YYYY-MM-DD HH:mm:ss');
            const EndDate = dayjs.utc(selectedSPALData.EndDate).format('YYYY-MM-DD HH:mm:ss');

            form.setFieldsValue({
                RangeDate: [dayjs(StartDate), dayjs(EndDate)],
            });
        }
    };

    const onSubmit = async (values) => {
        setLoadings(true);
        const { RangeDate } = values;

        const startDateRange = RangeDate ? dayjs(RangeDate[0]).format('YYYY-MM-DD HH:mm:ss') : null;
        const endDateRange = RangeDate ? dayjs(RangeDate[1]).format('YYYY-MM-DD HH:mm:ss') : null;

        fetchDataReading(startDateRange, endDateRange);
    };

    return (
        <div>
            <Form
                onFinish={onSubmit}
                form={form}
                initialValues={{
                    SPAL: selectedSPAL,
                }}
            >
                <div className="w-full flex border rounded-xl items-center justify-center p-2 lg:p-4 gap-2 lg:gap-4">
                    <div className="flex flex-col xl:flex-row gap-4">
                        <Form.Item
                            name="SPAL"
                            noStyle
                        >
                            <Select
                                onChange={handleSPALChange}
                                style={{ minWidth: '100px', width: 'auto' }}
                                placeholder="Select SPAL"
                                popupMatchSelectWidth={false}
                            >
                                {dataSPAL.map((item, index) => (
                                    <Option key={index} value={item.SONumber}>
                                        {item.SONumber} - {item.IsFinish ? "FINISH" : "UNFINISHED"}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="RangeDate"
                            noStyle
                        >
                            <RangePicker
                                showTime={{
                                    format: 'HH:mm:ss',
                                }}
                                format="YYYY-MM-DD HH:mm:ss"
                                disabled={true}
                            />
                        </Form.Item>
                    </div>
                    <Button htmlType="submit" icon={<SearchOutlined />} loading={loadings} style={{ width: '40px' }} />
                </div>
            </Form >
        </div>
    );
}

export default FilterRDSPAL;
